<template>
    <div class="block-bid-prebid" v-if="checkStateAuction !== CONSTANTS.AUCTION_STATE_END && checkAvailableTime">
        <div class="block-bid">
            <div class="block-time-end">
                <div class="block-top">
                    <div class="text">残り時間</div>
                    <div class="time-end">
                        <span class="number">{{ timeEnd }}</span>
                    </div>
                    <div class="d-flex justify-content-center mt-2">
                        <div class="">{{formattedDate}}</div>
                    </div>
                </div>
            </div>
            <div class="auto-end-time-extension mt-2 mb-20 text-center">
                <span v-if="product.auto_end_time_extension == CONSTANTS.PRODUCT_AUTO_END_TIME_EXTENSION">
                    終了までの５分間に競り上がれば自動延長されます
                </span>
            </div>
            <div class="block-sm">
                <div class="block-current-price">
                    <div class="current-price">
                        <div class="top">
                            <div v-if="this.isError" class="d-flex justify-content-center pb-10">
                                <div class="font-weight-bold text-center not-available-product">
                                    販売終了
                                </div>
                            </div>
                            <div class="font-weight-bold text-center">
                                現在価格
                            </div>
                            <div class="price color-red">
                                <span class="number">¥</span>
                                <span class="number">{{
                                        formatPrice(bidTop ? bidTop.amount : product.price_start_bid)
                                    }}</span>
                            </div>
                            <div class="tax-fee">
                                <span class="d-md-none">(</span>
                                <span class="text">消費税手数料込</span>
                                <span class="number">¥ {{
                                        handlePriceTaxAndServiceFee(bidTop ? bidTop.amount : product.price_start_bid)
                                    }}</span>
                                <span class="d-md-none">)</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="block-enter-bid">
                    <div class="left">入札額のご入力</div>
                </div>
                <div class="block-prie-bid">
                    <div class="block-top">
                        <div class="block-input">
                            <input type="text" id="input-bid" class="input-bid input-bid-online" maxlength="14"
                                   v-model="pricePlaced" @input="validateNumberInput()">
                        </div>
                    </div>
                    <div class="block-noti">
<!--                        <div class="text-updated"-->
<!--                             v-if="checkBidTop == 'type1'">-->
<!--                            <i class="icon fas fa-exclamation-circle"></i>-->
<!--                            <span>最低落札価格に達していません。</span>-->
<!--                        </div>-->
                        <div class="text-updated"
                             v-if="checkBidTop == 'type2' && this.bidTop">
                            <i class="icon fas fa-exclamation-circle"></i>
                            <span>あなたより他のお客様が高値で入札しました。</span>
                        </div>
                        <div class="text-updated" v-else-if="checkBidTop == 'type3' && this.bidTop">
                            <i class="icon fas fa-exclamation-circle"></i>
                            <span>あなたが現在の最高額入札者です。</span>
                        </div>
                    </div>
                    <div id="errors-price" class="error d-none">現在価格より大きい価格を入力してください。</div>
                    <div class="block-center">
                        <button class="btn-price-up ml-2" @click="increaseBidPrice('min')" :disabled="this.isError">
                            + ¥ 1,000
                        </button>
                        <button class="btn-price-up" @click="increaseBidPrice('medium')" :disabled="this.isError">
                            + ¥ 5,000
                        </button>
                        <button class="btn-price-up" @click="increaseBidPrice('max')" :disabled="this.isError">
                            + ¥ 10,000
                        </button>
                    </div>
                    <div class="block-bottom">
                        <button class="btn-send-price btn-large"
                                @click.prevent="handleSavePricePreBid"
                                :disabled="this.isError"
                        >
                            入札する
                        </button>
                        <!-- Modal -->
                        <div class="modal fade" id="priceBidProductModal" tabindex="-1"
                             aria-labelledby="exampleModalLabel"
                             aria-hidden="true" data-backdrop="static">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header border-bottom-0">
                                        <h3 class="modal-title font-weight-bold text-right" style="width: 59%">
                                            入札確認</h3>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="text-center mt-4">
                                        <span>入札価格 :</span>
                                        <span class="color-red" style="font-weight: 700">
                                            ¥{{ (typeof pricePlaced === 'string' && pricePlaced.includes(',')) ?
                                            pricePlaced : formatPrice(parseFloat(pricePlaced)) }}
                                        </span>
                                    </div>
                                    <div class="text-center mt-1">
                                        <span>手数料含む</span>
                                        <span>(¥{{
                                                (typeof pricePlaced === 'string' && pricePlaced.includes(',')) ?
                                            handlePriceTaxAndServiceFee(parseFloat(pricePlaced.replace(/,/g, ''))) :
                                            handlePriceTaxAndServiceFee(pricePlaced)
                                            }})</span>
                                    </div>
                                    <div class="text-center mt-1 mb-4">
                                        <span>この金額で入札する</span>
                                    </div>
                                    <div class="modal-footer border-top-0 justify-content-center">
                                        <button @click="storeBidOnline()"
                                                class="btn btn-submit-modal-bid-price-product">はい
                                        </button>
                                        <button type="button" class="btn btn-cancel-modal-bid-price-product"
                                                data-dismiss="modal">いいえ
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="block-history mt-4">
            <div class="text-history text-center">
                入札履歴
                <span> （{{ countHistory }}件）</span>
            </div>
            <div class="history">
                <div class="">
                    <div class="item-history" v-for="history in histories">
                        <div class="left-history ml-4">
                            <button class="tag tag-black" style="background: #FF6347 !important;">ONLINE</button>
                        </div>
                        <div class="right-history">
                            <div class="top"><strong>{{ history.member_id == member.id ? 'あなたの入札' : '' }}</strong>
                                ¥{{ formatPrice(history.amount) }}
                            </div>
                            <div class="bottom">{{ formatDate(history.created_at) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="block-bid-prebid" v-else>
        <div class="block-bid">
            <div class="block-sm">
                <div class="block-noti mb-20">
                    <div class="text-updated">
                        <i class="icon fas fa-exclamation-circle"></i>
                        <span>オークション期間は終了しました。</span>
                    </div>
                </div>
                <div class="block-current-price">
                    <div class="current-price">
                        <div class="top">
                            <div v-if="this.isError" class="d-flex justify-content-center pb-10">
                                <div class="font-weight-bold text-center not-available-product">
                                    販売終了
                                </div>
                            </div>
                            <div class="font-weight-bold text-center">
                                現在価格
                            </div>
                            <div class="price color-red">
                                <span class="number">¥</span>
                                <span class="number">{{
                                        formatPrice(bidTop ? bidTop.amount : product.price_start_bid)
                                    }}</span>
                            </div>
                            <div class="tax-fee">
                                <span class="d-md-none">(</span>
                                <span class="text">消費税手数料込</span>
                                <span class="number">¥ {{
                                        handlePriceTaxAndServiceFee(bidTop ? bidTop.amount : product.price_start_bid)
                                    }}</span>
                                <span class="d-md-none">)</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-history">
                <div class="text-history text-center">
                    入札履歴
                    <span> （{{ countHistory }}件）</span>
                </div>
                <div class="history">
                    <div class="">
                        <div class="item-history" v-for="history in histories">
                            <div class="left-history ml-4">
                                <button class="tag tag-black" style="background: #FF6347 !important;">ONLINE</button>
                            </div>
                            <div class="right-history">
                                <div class="top"><strong>{{ history.member_id == member.id ? 'あなたの入札' : '' }}</strong>
                                    ¥{{ formatPrice(history.amount) }}
                                </div>
                                <div class="bottom">{{ formatDate(history.created_at) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import CONSTANTS from "../constants";
import moment from "moment-timezone";
import {COMMON} from "./../../common";

export default {
    mounted() {
    },
    async created() {
        await this.getDataBid();
        await this.getAuctionProduct();
        await this.countDownTime(this.newEndTime);

        Echo.channel('auction.check_error_product'  + this.auction.id + '.' + this.product.id)
            .listen('.auction.check_error_product',  (e) => {
                this.getAuctionProduct();
            });

        Echo.channel('auction.set_time_end' + this.auction.id + '.' + this.product.id)
            .listen('.auction.set_time_end', (e) => {
                this.getDataBid();
            });

        Echo.channel('bid.online_bid.' + this.auction.id + '.' + this.product.id)
            .listen('.bid.online_bid.sent', (e) => {
                this.histories.unshift(e.myBid)
                this.bidTop = e.bidTop;
                this.countHistory = this.histories.length;
                if(e.newEndTime) {
                    if (this.checkStateAuction !== CONSTANTS.AUCTION_STATE_END) {
                        this.newEndTime = e.newEndTime;
                        this.countDownTime(this.newEndTime);

                        this.interval = setInterval(() => {
                            this.countDownTime(this.newEndTime);
                        }, 1000);
                    }
                }
                this.getDataBid();
            });

        Echo.channel('bid.update_price.' + this.auction.id + '.' + this.product.id)
            .listen('.bid.update_price.sent', (e) => {
                this.histories.unshift(e.myBid)
                this.bidTop = e.bidTop;
                this.countHistory = this.histories.length;
            });

        Echo.channel('bid.online_bid.' + this.auction.id)
            .listen('.bid.online_bid.start', (e) => {
                if (this.auction.id == e.auction.id) {
                    this.checkStateAuction = e.auction.state;

                    if (this.checkStateAuction !== CONSTANTS.AUCTION_STATE_END) {
                        this.countDownTime(this.newEndTime);

                        this.interval = setInterval(() => {
                            this.countDownTime(this.newEndTime);
                        }, 1000);
                    }
                }
            });

        Echo.channel('bid.online_bid.' + this.auction.id)
            .listen('.bid.online_bid.end', (e) => {
                if (this.auction.id == e.auction.id) {
                    this.checkStateAuction = e.auction.state;

                    if (this.checkStateAuction == 5 && !this.checkAvailableTime) {
                        window.location.href = `/auction/${this.auction.id}/detail`;
                    }
                }
            });

        if ((this.checkStateAuction !== CONSTANTS.AUCTION_STATE_END && this.checkAvailableTime)) {
            this.countDownTime(this.newEndTime);

            this.interval = setInterval(() => {
                this.countDownTime(this.newEndTime);
            }, 1000);
        }

        Echo.channel('auction.' + this.auction.id)
            .listen('.auction.setting.product_end_time', (e) => {
                if (this.auction.id == e.auction.id) {
                    window.location.reload();
                }
            });

        Echo.channel('auction_product.' + this.auction.id + '.' + this.product.id)
            .listen('.auction_product.update_end_time', (e) => {
                if (this.checkStateAuction !== CONSTANTS.AUCTION_STATE_END) {
                    this.newEndTime = e.newEndTime;
                    this.countDownTime(this.newEndTime);

                    this.interval = setInterval(() => {
                        this.countDownTime(this.newEndTime);
                    }, 1000);
                }
            });
    },
    props: [
        'product',
        'auction',
        'product_auction'
    ],
    data: function () {
        return {
            serviceFee: 0,
            tax: 0,
            countHistory: 0,
            pricePlaced: 0,
            timeEnd: null,
            interval: null,
            bidTop: null,
            myBidTop: null,
            member: null,
            histories: null,
            checkStateAuction: this.auction.state,
            checkProductAuction: this.product_auction,
            isError: false,
            newEndTime: null,
            formattedDate: null,
            currentTime: moment().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss'),
        }
    },
    methods: {
        async getDataBid() {
            await axios.post('/bid/get-data-bid-online', {
                auctionId: this.auction.id,
                productId: this.product.id,
            })
                .then(res => {
                    this.pricePlaced = res.data.myBidTop ? this.formatPrice(res.data.myBidTop.amount) : 0;
                    this.bidTop = res.data.bidTop;
                    this.member = res.data.member;
                    this.histories = res.data.histories;
                    this.myBidTop = res.data.myBidTop;
                    this.countHistory = res.data.histories ? res.data.histories.length : 0;
                    this.serviceFee = res.data.taxConfig.service_fee;
                    this.tax = res.data.taxConfig.tax;
                    this.newEndTime = res.data.newEndTime;
                    this.formattedDate = this.formatDateJapanese(res.data.newEndTime);
                })
                .catch(error => {

                })
        },

        formatDateJapanese(dateString) {
            const date = new Date(dateString)

            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')

            const daysOfWeek = ['日', '月', '火', '水', '木', '金', '土']
            const dayOfWeek = daysOfWeek[date.getDay()]

            return `${month}/${day}(${dayOfWeek}) ${hours}:${minutes} 終了予定`
        },

        async getAuctionProduct() {
            await axios.post('/bid/get-data-auction-product', {
                auctionId: this.auction.id,
                productId: this.product.id,
            })
                .then(res => {
                    this.checkProductAuction = res.data.auctionProduct;
                    this.isError = !!res.data.auctionProduct.is_error;
                })
                .catch(error => {

                })
        },

        async storeBidOnline() {
            if ((this.checkStateAuction !== CONSTANTS.AUCTION_STATE_END && this.checkAvailableTime) &&
                this.checkBidPermission() == CONSTANTS.CAN_BID) {
                this.clearValue();

                if (!document.getElementById('errors-price').classList.contains('d-none')) {
                    document.getElementById('errors-price').classList.add('d-none')
                }

                if (this.bidTop) {
                    if (this.pricePlaced && this.bidTop && this.pricePlaced > this.bidTop.amount) {
                        await axios.post('/bid/store-bid-online', {
                            auctionId: this.auction.id,
                            productId: this.product.id,
                            amount: this.pricePlaced,
                        })
                            .then(response => {
                                if (response.data.myBidTop) {
                                    this.myBidTop = response.data.myBidTop;
                                    this.getDataBid();
                                }
                            })
                            .catch(error => {
                                if (error.response.status === 422) {
                                    alert('オークション期間は終了しました。');
                                    window.location.reload();
                                } else if (error.response.status === 400){
                                    document.getElementById('errors-price').classList.remove('d-none');
                                    setTimeout(function () {
                                        document.getElementById('errors-price').classList.add('d-none');
                                    }, 5000)
                                }
                            })
                    } else {
                        document.getElementById('errors-price').classList.remove('d-none');
                        setTimeout(function () {
                            document.getElementById('errors-price').classList.add('d-none');
                        }, 5000)
                    }
                    this.closeModal();
                } else {
                    if (this.pricePlaced && this.pricePlaced > this.product.price_start_bid) {
                        await axios.post('/bid/store-bid-online', {
                            auctionId: this.auction.id,
                            productId: this.product.id,
                            amount: this.pricePlaced,
                        })
                            .then(response => {
                                if (response.data.myBidTop) {
                                    this.myBidTop = response.data.myBidTop;
                                    this.getDataBid();
                                }
                            })
                            .catch(error => {
                                if (error.response.status === 422) {
                                    alert('オークション期間は終了しました。');
                                    window.location.reload();
                                } else if (error.response.status === 400){
                                    document.getElementById('errors-price').classList.remove('d-none');
                                    setTimeout(function () {
                                        document.getElementById('errors-price').classList.add('d-none');
                                    }, 5000)
                                }
                            })
                    } else {
                        document.getElementById('errors-price').classList.remove('d-none');
                        setTimeout(function () {
                            document.getElementById('errors-price').classList.add('d-none');
                        }, 5000)
                    }
                    this.closeModal();
                }
            } else {
                switch (this.checkBidPermission()) {
                    case CONSTANTS.NOT_MEMBER:
                        document.getElementsByClassName('not-member')[0].classList.remove('d-none');
                        break;
                    case CONSTANTS.CAN_NOT_BID:
                        document.getElementsByClassName('can-not-bid')[0].classList.remove('d-none');
                        break;
                }
                document.getElementById('input-bid').value = '';
                this.closeModal();
            }
        },

        clearValue() {
            return document.getElementsByClassName('input-bid')[0].value = '';
        },

        formatPrice(price) {
            return COMMON.handleFormatPrice(price);
        },

        increaseBidPrice(type) {
            if (!this.isError) {
                this.parseIntPricePlaced();
                if (this.pricePlaced) {
                    this.checkTypeAddPrice(type, this.pricePlaced);
                } else {
                    if (this.bidTop) {
                        this.checkTypeAddPrice(type, this.bidTop.amount);
                    } else {
                        this.checkTypeAddPrice(type, this.product.price_start_bid);
                    }
                }
            }
        },

        checkTypeAddPrice(type, price) {
            if (type === 'min') {
                this.pricePlaced = price + 1000;
            } else if (type === 'medium') {
                this.pricePlaced = price + 5000;
            } else {
                this.pricePlaced = price + 10000;
            }
        },

        handlePriceRange(amountBidTop) {
            let priceIncreaseMin = null;
            let priceIncreaseMax = null;

            if (amountBidTop >= 0 && amountBidTop <= 100000) {
                priceIncreaseMin = 1000;
                priceIncreaseMax = 10000;
            } else if (amountBidTop > 100000 && amountBidTop <= 500000) {
                priceIncreaseMin = 5000;
                priceIncreaseMax = 50000;
            } else if (amountBidTop > 500000 && amountBidTop <= 5000000) {
                priceIncreaseMin = 10000;
                priceIncreaseMax = 100000;
            } else if (amountBidTop > 5000000) {
                priceIncreaseMin = 50000;
                priceIncreaseMax = 500000;
            }

            return {
                priceIncreaseMin: priceIncreaseMin,
                priceIncreaseMax: priceIncreaseMax
            }
        },

        countDownTime(endTime = null) {
            this.timeEnd = COMMON.handleCountDownTime(null, endTime ?? this.auction.end_time, this.auction.start_time, this.interval);
            if(this.timeEnd === "0 : 0 : 0 ") {
                this.currentTime = moment().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss')
            }
            return this.timeEnd;
        },

        formatDate(time) {
            return COMMON.handleFormatDate(time);
        },

        validateNumberInput() {
            this.pricePlaced = event.target.value.replace(/[^0-9]/g, '').substring(0, 14);
        },

        checkBidPermission() {
            if (this.member.status != 1) {
                return CONSTANTS.NOT_MEMBER;
            }

            return CONSTANTS.CAN_BID;
        },

        handlePriceTaxAndServiceFee(pricePresent) {
            let price = COMMON.handlePriceTaxAndServiceFee(parseFloat(pricePresent), this.serviceFee, this.tax);
            return this.formatPrice(price);
        },

        parseIntPricePlaced() {
            if (this.pricePlaced && typeof this.pricePlaced === 'string') {
                this.pricePlaced = parseInt(this.pricePlaced.replace(/[^0-9]/g, ''))
            }
        },

        handleSavePricePreBid() {
            if (!this.isError) {
                if (this.bidTop) {
                    if (this.bidTop.amount < this.pricePlaced) {
                        this.openModal();
                    } else {
                        document.getElementById('errors-price').classList.remove('d-none');
                        setTimeout(function () {
                            document.getElementById('errors-price').classList.add('d-none');
                        }, 5000)
                    }
                } else {
                    if (this.product.price_start_bid < this.pricePlaced) {
                        this.openModal();
                    } else {
                        document.getElementById('errors-price').classList.remove('d-none');
                        setTimeout(function () {
                            document.getElementById('errors-price').classList.add('d-none');
                        }, 5000)
                    }
                }
            }
        },

        openModal() {
            $('#priceBidProductModal').modal('show');
        },

        closeModal() {
            $('#priceBidProductModal').modal('hide');
        },
    },
    computed: {
        CONSTANTS() {
            return CONSTANTS
        },
        checkBidTop: function () {
            if (
                this.myBidTop && this.bidTop && this.bidTop.member_id != this.member.id
            ) {
                return 'type2'
            }

            if (
                this.bidTop && this.bidTop.member_id == this.member.id
            ) {
                return 'type3'
            }
            if (
                this.myBidTop && this.myBidTop.amount < this.product.price_lowest_winning
            ) {
                return 'type1'
            }

            return null;
        },

        checkAvailableTime: function () {
            let auctionLiveStartTime = moment(this.auction.start_time).format('YYYY-MM-DD HH:mm:ss');
            let auctionLiveEndTime = moment(this.auction.end_time).format('YYYY-MM-DD HH:mm:ss');
            let auctionProductEndTime = this.product_auction.end_time_online ? moment(this.product_auction.end_time_online).format('YYYY-MM-DD HH:mm:ss') : null;
            return !!(auctionLiveStartTime && auctionLiveEndTime && ((this.currentTime > auctionLiveStartTime) && (this.currentTime < auctionLiveEndTime && (auctionProductEndTime && this.currentTime < auctionProductEndTime))));
        },
    },
}
</script>
